export default "__VITE_ASSET__4L$ghc6J__"